import {
  SET_PRODUCT,
  SET_PLUGIN_INFO,
  SET_BRIEFS,
  SET_BRIEFS_LOADING
} from './product.constants';


const initialState = {
  briefs: [],
  briefsLoading: false,
  product: {},
  pluginInfo: {},
};

const productReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case SET_BRIEFS: {
      return {
        ...state,
        briefs: payload,
      }
    }

    case SET_BRIEFS_LOADING: {
      return {
        ...state,
        briefsLoading: payload,
      }
    }

    case SET_PRODUCT: {
      return {
        ...state,
        product: payload,
      }
    }

    case SET_PLUGIN_INFO: {
      return {
        ...state,
        pluginInfo: payload,
      }
    }

    default:
      return state;
  }
};

export default productReducer;
